<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/j3Bb7E/tc-custom/9781429994538.jpg?1720014971925" alt="This image is the cover for the book Forbidden, Vampire Huntress Legend Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forbidden, Vampire Huntress Legend Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Hell hath no fury like a woman scorned in <i>The Forbidden</i>, the exciting fifth book in L. A. Banks's Vampire Huntress series.</b><br/><br/>After the destruction of all the topside master vampires and the death and resurrection of her council-level vampire lover, Damali is called before the Council of the Neterus to answer for her actions. It is there that she discovers there are consequences even she could not foresee. <br/><br/>She also learns that the consort of the Un-Named One, Lilith, has come up from the seventh level to set the affairs of the Dark Realms in order. However, Lilith has a hidden agenda of her own and it involves the unborn child Damali <i>thought</i> had been taken from her. <br/><br/>The news devastates Damali until a cold and deadly determination leads her to map out a plan for Lilith's destruction. An evil force beyond recognition, Damali's newest nemesis literally brings men to their knees. But Damali will not be stopped---not even by someone as dangerously powerful as Lilith. It is a battle that spills over into the streets and involves the people Damali has sworn to protect, leaving fewer standing before it's all over.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        L. A. Banks
      </h2>
      
      <p class="authorDescription body article"><P><B>L. A. BANKS</B> is the author of the Vampire Huntress Legend series and the Crimson Moon Novels. She had a bachelor's degree from the University of Pennsylvania's Wharton School of Business and a master's in fine arts from Temple University. Banks considered herself a shape-shifter. She wrote romance, women's fiction, crime and suspense, and of course, dark vampire huntress lore. She lived with her daughter in an undisclosed lair somewhere in Philadelphia.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dbf51f40